import { render, staticRenderFns } from "./LessonSchedules.vue?vue&type=template&id=fa5ba8f4&scoped=true&"
import script from "./LessonSchedules.vue?vue&type=script&lang=js&"
export * from "./LessonSchedules.vue?vue&type=script&lang=js&"
import style0 from "./LessonSchedules.vue?vue&type=style&index=0&id=fa5ba8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ba8f4",
  null
  
)

export default component.exports